import { useAuth } from '../context/AuthContext';
import { SupervisorDashboard } from './SupervisorDashboard';
import { SectorDashboard } from './SectorDashboard';
import { OperatorDashboard } from './OperatorDashboard';
import { QualityDashboard } from './QualityDashboard';
import { SuperAdminDashboard } from './SuperAdminDashboard';

export function Dashboard() {
  const { user } = useAuth();

  // Superadmin vê o painel global
  if (user?.role === 'superadmin') {
    return <SuperAdminDashboard />;
  }

  // Redireciona para o dashboard apropriado de cada perfil
  if (user?.role === 'supervisor') {
    return <SupervisorDashboard />;
  }

  if (user?.role === 'qualidade') {
    return <QualityDashboard />;
  }

  if (user?.role === 'admin') {
    return <SectorDashboard />;
  }

  // Dashboard do Operador (default)
  return <OperatorDashboard />;
}